module.exports = __webpack_public_path__ + "static/media/InventoryIconActive.571aa9ab.svg";